import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../css/ActualWorking.css";
import { useNavigate, useLocation } from "react-router-dom";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";

const ActualWorking = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [states, setStates] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [selectedState, setSelectedState] = useState("");
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [selectedMonthYear, setSelectedMonthYear] = useState("");
    const [showTable, setShowTable] = useState(false);
    const [monthData, setMonthData] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [employeeName, setEmployeeName] = useState("");

    // Get current month/year
    const getCurrentMonthYear = () => {
        const date = new Date();
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        return `${month} ${year}`;
    };

    // Populate month/year options
    const generateMonthYearOptions = () => {
        const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const currentYear = new Date().getFullYear();
        
        // Return only current year's months
        return months.map(month => `${month} ${currentYear}`);
    };
    // Update month/year selection handler
    const handleMonthYearChange = (value) => {
        const [monthName, year] = value.split(' ');
        const monthIndex = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ].indexOf(monthName);
        
        setSelectedMonth(monthIndex + 1);
        setSelectedYear(parseInt(year));
        setSelectedMonthYear(value);
    };

    useEffect(() => {
        fetch(`${BASE_URL}/api/states`,{
          headers:getAuthHeaders()
        })
        .then((res) => res.json())
        .then((data) => setStates(data))
        .catch((err) => console.error("State fetch error:", err));
    }, []);

    useEffect(() => {
        if (selectedState) {
        fetch(`${BASE_URL}/api/employees?state_id=${selectedState}`,{
          headers:getAuthHeaders()
        })
            .then((res) => res.json())
            .then((data) => setEmployees(data))
            .catch((err) => console.error(err));
        } else {
        setEmployees([]);
        setSelectedEmployee("");
        }
    }, [selectedState]);

    useEffect(() => {
        setSelectedMonthYear(getCurrentMonthYear());
    }, []);

    const generateMonthDays = (month, year) => {
        const daysInMonth = new Date(year, month, 0).getDate();
        const days = [];
        
        for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, month - 1, day);
        const dayOfWeek = date.getDay(); // 0 = Sunday, 1 = Monday, etc.
        
        days.push({
            date: day,
            fullDate: dayOfWeek === 0 
            ? `${day} ${new Date(year, month - 1).toLocaleString('default', { month: 'short' })} ${year} Sunday`
            : `${day} ${new Date(year, month - 1).toLocaleString('default', { month: 'short' })} ${year}`,
            dayName: date.toLocaleDateString('en-US', { weekday: 'long' }),
            isSunday: dayOfWeek === 0
        });
        }
        
        return days;
    };

    const fetchTourPrograms = async (employeeId, month, year) => {
        try {
        const response = await fetch(
            `${BASE_URL}/api/combined-retailers/employee-tour-details/${employeeId}/month?month=${month}&year=${year}`
        );
        console.log("API Response", response)
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
        } catch (error) {
        console.error("Error fetching tour programs:", error);
        return []; // Return empty array on error
        }
    };

    // Update the handleGoClick function
    const handleGoClick = async () => {
        if (!selectedState || !selectedEmployee) {
          alert("Please select a State and Employee.");
          return;
        }
      
        const selectedEmp = employees.find(emp => emp.id === parseInt(selectedEmployee));
        if (selectedEmp) {
          setEmployeeName(`${selectedEmp.first_name} ${selectedEmp.last_name} ${selectedEmp.designation}`);
        }
      
        try {
          const apiData = await fetchTourPrograms(selectedEmployee, selectedMonth, selectedYear);
          
          const processedData = apiData.map(day => {
            const dateObj = new Date(day.date);
            const monthName = dateObj.toLocaleString('default', { month: 'short' });
            const year = dateObj.getFullYear();
            
            // Format programs for display
            let routeDisplay = 'N/A';
            let stateDisplay = 'N/A';
            let cityDisplay = 'N/A';
            let workingWithDisplay = 'N/A';
            let remarksDisplay = 'N/A';
            
            if (day.programs.length > 0) {
              routeDisplay = day.programs.map(p => `${p.route_name || p.route_id}`).join('<br/>');
              stateDisplay = day.programs.map(p => `${p.state}`).join('<br/>');
              cityDisplay = day.programs.map(p => `${p.city}`).join('<br/>');
              workingWithDisplay = day.programs.map(p => {
                if (p.working_with_id === parseInt(selectedEmployee)) {
                  return "Individual";
                } else {
                  return p.working_with_name
                    ? `${p.working_with_name} (${p.working_with_designation} | ${p.working_with_division} | ${p.working_with_headquarter_name} | ${p.working_with_state_name})`
                    : 'N/A';
                }
              }).join('<br/>');
              remarksDisplay = day.programs.map(p => `${p.remarks || 'N/A'}`).join('<br/>');
            }
            
            return {
              ...day,
              fullDate: day.is_sunday 
                ? `${day.day} ${monthName} ${year} Sunday`
                : `${day.day} ${monthName} ${year}`,
              hasData: !day.is_sunday && day.programs.length > 0,
              programData: day.is_sunday ? null : {
                route_id: routeDisplay,
                state: stateDisplay,
                city: cityDisplay,
                working_with_employee_id: workingWithDisplay,
                remarks: remarksDisplay
              }
            };
          });
      
          setMonthData(processedData);
          setShowTable(true);
        } catch (error) {
          console.error("Error processing tour programs:", error);
          alert("Failed to load tour programs. Please try again.");
        }
      };

    const getCellStyle = (day) => {
        if (day.is_sunday) {
        return { backgroundColor: '#90EE90' }; // Light green for Sundays
        }
        if (!day.hasData) {
        return { backgroundColor: '#FFCCCB' }; // Light red for days without data
        }
        return {}; // Default style for days with data
    };

    const formatWorkingWith = (workingWith) => {
        if (!workingWith) return 'N/A';
        return workingWith;
    };

  return (
    <div className="actualworking-container">
      <Header />
      <Navbar />
      
      {/* Filter Section */}
      <div className="actualworking-filter-container">
        <div className="actualworking-filter-heading">
          <h2 className="actualworking-filter-title">Executive Tour Program</h2>
        </div>
          <div className="actualworking-filter-row1">
            
              <label className="actualworking-label">State</label>
              <select
                className="actualworking-dropdown"
                value={selectedState}
                onChange={(e) => setSelectedState(e.target.value)}
                required 
              >
                <option value="">Select</option>
                {states.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.name}
                  </option>
                ))}
              </select>
 
              <label className="actualworking-label">Employee</label>
              <select
                className="actualworking-dropdown"
                value={selectedEmployee}
                onChange={(e) => setSelectedEmployee(e.target.value)}
                required
              >
                <option value="">Select</option>
                {employees.map((emp) => (
                  <option key={emp.id} value={emp.id}>
                    {emp.first_name} {emp.last_name} | {emp.employee}  {emp.designation}|{emp.headquarter_name}|{emp.division}|{emp.state_name}
                  </option>
                ))}
              </select>
          </div>
          <div className="actualworking-filter-row2">
              <label className="actualworking-label">Month/Year</label>
              <select
                className="actualworking-dropdown"
                value={selectedMonthYear}
                onChange={(e) => handleMonthYearChange(e.target.value)}
              >
                {generateMonthYearOptions().map((option) => (
                  <option key={option}>{option}</option>
                ))}
              </select>
            <div className="actualworking-go-button">
              <button className="actualworking-filter-go-button" onClick={handleGoClick}>GO</button>
            </div>
          </div>

      </div>

      {/* Table Section */}
      {showTable && (
        <div className="actualworking-table-container">
          <div className="actualworking-table-heading">
            <h2 className="actualworking-results-title">Employee Tour Details:-{employeeName} ({new Date(selectedYear, selectedMonth - 1).toLocaleString('default', { month: 'long' })} {selectedYear})</h2>
          </div>
          <table>
            <thead className="text-white">
                <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Leave Meeting</th>
                <th>Employee</th>
                <th>Emp TP WW</th>
                <th>Emp TP Route/City</th>
                <th>Emp Route Covered</th>
                <th>Emp TP Retailer (Dr+Rtr)</th>
                <th>Emp Calls</th>
                <th>Emp WW Calls</th>
                <th>Emp Stockist</th>
                <th>Working With</th>
                <th>WW Desig</th>
                <th>WW Total Calls</th>
                <th>WW Emp Total Calls</th>
                <th>WW Productive Calls</th>
                <th>WW POB</th>
                <th>Location match</th>
                </tr>
            </thead>
            <tbody>
                {monthData.map((day, index) => {
                const firstProgram = day.programs[0] || {};
                return (
                    <tr key={index} style={getCellStyle(day)}>
                    <td>{index + 1}</td>
                    <td>{day.fullDate}</td>
                    <td>{day.is_leave ? day.leave_type || "Leave" : ""}</td>
                    <td>{employeeName}</td>
                    {/* <td dangerouslySetInnerHTML={{ __html: day.isSunday ? 'N/A' : (firstProgram.working_with_name || 'N/A') }} /> */}
                    <td>
                        {day.isSunday || day.programs.length === 0 ? 'N/A' : (
                            day.programs.map((p, index) => (
                            <div key={index}>
                                {p.working_with_name 
                                ? `${p.working_with_name} (${p.working_with_designation || 'N/A'} | ${p.working_with_headquarter_name || 'N/A'})`
                                : 'Individual'}
                            </div>
                            ))
                        )}
                        </td>
                        <td>
                            {day.isSunday || day.programs.length === 0 ? 'N/A' : (
                                day.programs.map((p, index) => (
                                <div key={index}>
                                    {p.route_name || 'N/A'} ({p.city || 'N/A'})
                                </div>
                                ))
                            )}
                            </td>
                    <td>{firstProgram.route_covered || 'N/A'}</td>
                    <td>{firstProgram.emp_tp_retailers || 0}</td>
                    <td>{firstProgram.emp_calls || 0}</td>
                    <td>{firstProgram.emp_ww_calls || 0}</td>
                    <td>{firstProgram.emp_stockists || 0}</td>
                    <td>
                    {day.isSunday || day.programs.length === 0 ? 'N/A' : (
                        day.programs.map((p, index) => (
                        <div key={index}>
                            {p.working_with_id === parseInt(selectedEmployee)
                            ? 'Individual'
                            : p.working_with_name || 'N/A'}
                        </div>
                        ))
                    )}
                    </td>
                    <td>
                        {day.isSunday || day.programs.length === 0 ? 'N/A' : (
                            day.programs.map((p, index) => (
                            <div key={index}>
                                {p.working_with_designation || 'N/A'}
                            </div>
                            ))
                        )}
                        </td>
                    <td>{firstProgram.ww_total_calls || 0}</td>
                    <td>{firstProgram.ww_emp_total_calls || 0}</td>
                    <td>{firstProgram.ww_productive_calls || 0}</td>
                    <td>{firstProgram.ww_pob || 0}</td>
                    <td>{firstProgram.location}</td>
                    </tr>
                );
                })}
            </tbody>
            </table>
        </div>
      )}
      
      <Footer />
    </div>
  );
};

export default ActualWorking;